import { DELIVERY_APPS } from "../data/nap";

export const SHORTER_MENU = "GT Dhaba menu not on the apps";

// Official "Order on…" badge slot. Until Rajveer supplies the platforms' merchant-kit badge files, these ship as
// clean text buttons in our own type — never traced, redrawn or recoloured logos. Drop official assets in
// frontend/public/badges/{key}.svg and set `badge` on the app entry in seo_content.json to switch them on.
export function DeliveryBadges({ label = "Delivery", compact = false, testPrefix = "delivery" }) {
  const size = compact ? "text-[11px] px-2.5 py-1" : "text-xs px-3 py-1.5";
  return (
    <div className="inline-flex flex-wrap items-center gap-1.5" data-testid={`${testPrefix}-badges`}>
      {label && <span className={`font-bold text-neutral-700 ${compact ? "text-[11px]" : "text-xs"} mr-0.5`}>{label}</span>}
      {DELIVERY_APPS.map((a) => (
        <a key={a.key} href={a.url} target="_blank" rel="noopener noreferrer" data-testid={`${testPrefix}-badge-${a.key}`}
          className={`inline-flex items-center rounded-full border border-neutral-300 bg-white hover:border-black font-bold ${size} transition-colors`}>
          {a.badge ? <img src={a.badge} alt={`Order on ${a.label}`} className="h-4" /> : a.label}
        </a>
      ))}
      <span className={`text-neutral-500 ${compact ? "text-[10px]" : "text-[11px]"} ml-0.5`} data-testid={`${testPrefix}-shorter-menu`}>{SHORTER_MENU}</span>
    </div>
  );
}
